import { Box, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  textBold: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "24px",
    fontWeight: 700,
    color: "#114668",
    alignSelf: "end",
    textAlign: "right",
  },
  textLight: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "24px",
    fontWeight: 300,
    color: "#114668",
    alignSelf: "start",
    marginRight: "10px",
  },
  textLightBig: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "30px",
    fontWeight: 300,
    color: "#114668",
    alignSelf: "center",
    marginBottom: "12px",
  },
  horizontalBox: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "0px 24px 0px 24px",
  },
  buttonBox: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "24px 24px 0px 24px",
    flexDirection: "column",
  },
  break: {
    width: "100%",
    height: "1px",
    marginBottom: "24px",
    backgroundColor: "#bcbcbc",
  },
}));

const AssistanceView = ({ assistanceData, eklokData }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  console.log(assistanceData);

  return (
    <>
      <Box className={classes.buttonBox}>
        <Typography className={classes.textLightBig}>
          {t("mobile_frame.home.installer_data")}
        </Typography>
        <Box className={classes.break} />
      </Box>
      <Box className={classes.horizontalBox}>
        <Typography className={classes.textLight}>
          {t("mobile_frame.home.eklok_name")}
        </Typography>
        <Typography className={classes.textBold}>{eklokData.name}</Typography>
      </Box>
      <Box className={classes.horizontalBox}>
        <Typography className={classes.textLight}>
          {t("mobile_frame.home.support_address")}
        </Typography>
        <Typography className={classes.textBold}>
          {assistanceData.SUPPORT_ADDRESS}
        </Typography>
      </Box>
      <Box className={classes.horizontalBox}>
        <Typography className={classes.textLight}>
          {t("mobile_frame.home.support_company")}
        </Typography>
        <Typography className={classes.textBold}>
          {assistanceData.SUPPORT_COMPANY}
        </Typography>
      </Box>
      <Box className={classes.horizontalBox}>
        <Typography className={classes.textLight}>
          {t("mobile_frame.home.support_mail")}
        </Typography>
        <Typography className={classes.textBold}>
          {assistanceData.SUPPORT_MAIL}
        </Typography>
      </Box>
      <Box className={classes.horizontalBox}>
        <Typography className={classes.textLight}>
          {t("mobile_frame.home.support_phone")}
        </Typography>
        <Typography className={classes.textBold}>
          {assistanceData.SUPPORT_PHONE}
        </Typography>
      </Box>
      <Box className={classes.horizontalBox}>
        <Typography className={classes.textLight}>
          {t("mobile_frame.home.support_website")}
        </Typography>
        <Typography className={classes.textBold}>
          {assistanceData.SUPPORT_WEBSITE}
        </Typography>
      </Box>
    </>
  );
};

export default AssistanceView;
